let appMode = process.env.REACT_APP_ENV;
let ASSET_URL =
  "https://dunnnit.s3.me-central-1.amazonaws.com/";
let URL;

console.log("appMode", appMode);

// 3.20.147.34

if (appMode === "development") {
  // URL = "http://localhost:1200/api/";
  // URL = "https://backend.dunnnit.com/api/";
  URL = "https://meanstack.smartdatainc.com:9322/api/"
} else {
  // URL = "https://meanstack.smartdatainc.com:9322/api/"
  URL = "https://backend.dunnnit.com/api/";
  // URL = "http://localhost:1200/api/";
}

let apiPath = {
  baseURL: URL,
  assetURL: ASSET_URL,
  dashboard: "admin/dashboard",
  importStockData: "admin/dashboard/import-stock-price",
  getStockData: "common/dashboard/get-stock-price",

  order: "admin/order",
  viewOrder: "admin/order/view",
  statusOrder: "admin/order/status",
  transaction: "admin/transaction",

  // Auth API
  logout: "admin/auth/logout",
  login: "admin/auth/login",

  allRole: "admin/role",
  login: "admin/auth/login",

  profile: "admin/auth/get-profile",
  updateProfile: "admin/auth/update-profile",
  changePassword: "admin/auth/change-password",
  updateAppSetting: "admin/auth/update-app-setting",

  forgotPassword: "admin/auth/forgot-password",
  verifyOTP: "admin/auth/verify-otp",
  resetPassword: "admin/auth/reset-password",

  // SubAdmin APIs
  subAdmin: "admin/sub-admin",
  addEditSubAdmin: "admin/sub-admin",
  statusSubAdmin: "admin/sub-admin/status",
  viewSubAdmin: "admin/sub-admin/view",
  getModule: "admin/sub-admin/module-list",
  addPermission: "admin/sub-admin/add-permission",
  log: "admin/change-log",
  logRead: "admin/change-log/read",

  // Role APIs
  role: "admin/role",
  statusRole: "admin/role/status",

  // Customer APIs
  listCustomer: "admin/customer",
  addEditCustomer: "admin/customer",
  viewCustomer: "admin/customer/view",
  deleteCustomer: "admin/customer/delete",
  statusCustomer: "admin/customer/status",
  importCustomer: "admin/customer/import-file",
  getPairings: "admin/customer/pairings",
  getUserStats: "admin/customer/stats",
  getUserchlg: "admin/customer/challenges",
  getStoreData: "admin/customer/store-data",
  listTargetedUsers: "admin/customer/target-users",

  // Challenge APIs
  addChallenge: "admin/challenge",
  getChallenges: "admin/challenge",
  getAllChallenges: "admin/challenge",
  statusChallenge: "admin/challenge/status",
  deleteChallenge: "admin/challenge/delete",
  getEmojis: "admin/challenge/emojis",
  getChallengePieChart: "admin/challenge/pie-chart",

  // Challenge APIs
  getUserChallenges: "admin/user-challenge",
  getUserChallengeHistory: "admin/user-challenge/history",
  getUserChallengeJRHistory: "admin/customer/challenge-journey-history",

  // Challenge APIs
  getSupport: "admin/support",

  // Feed APIs
  addFeed: "admin/feed",
  getFeeds: "admin/feed",
  getFeedcomments: "admin/feed/comment-list",
  deleteFeedComment: "admin/feed/delete-comment",
  deleteFeed: "admin/feed/delete",
  reportFeed: "admin/feed/report/",

  // Order APIs
  orderList: "admin/customer/order",
  transactionList: "admin/customer/transaction",

  //Coupon Apis
  listCoupon: "admin/coupon",

  // LeaderBoard APIs
  getLeaderboard: "admin/leaderboard",

  banner: "admin/banner",
  adminCommon: "admin/common",

  // Content APIs
  content: "admin/content",
  notification: "admin/notification",
  notificationRead: "admin/notification/read-all",
  rating: "admin/rating",

  // EmailTemplate APIs
  listEmailTemplate: "admin/email-template/list",
  addEditEmailTemplate: "admin/email-template/add-edit",
  statusEmailTemplate: "admin/email-template/status",
  viewEmailTemplate: "admin/email-template/view",
  sendMail: "admin/email-template/send-mail",

  //Category
  listCategory: "admin/category",
  statusCategory: "admin/category/status",

  //Content Media
  contentMedia: "admin/media-content",

  //Subscription
  listSubscriptions: "admin/subscription/list",

  //Attribute List
  listAttribute: "admin/attribute",

  //Product catalogue
  listProduct: "admin/product",
  viewProduct: "admin/product/view",
  listProductVariant: "admin/product-variant",

  imageUpload: "common/image-upload",

  common: {
    notification: "common/notify",
    content: "common/content",
    categories: "common/categories",
    allCustomer: "common/users",
    challenges: "common/challenges",
    attributes: "common/attributes",
    subAdmin: "common/sub-admin",
  },
};

export default apiPath;
